// in src/MyLayout.js
import { Layout } from 'react-admin';
import { CustomAppBar } from './customAppBar';

export const customAppLayout = (props) => (
    <Layout {...props} appBar={CustomAppBar}>
    </Layout>
);